import { Group } from '../types';

export enum CampaignScopeType {
  NETWORK = 'NETWORK',
  GROUP = 'GROUP',
}

export interface BaseCampaignScope {
  readonly type: CampaignScopeType;
}

export interface CampaignGroupScope extends BaseCampaignScope {
  readonly type: CampaignScopeType.GROUP;
  readonly groupId: Group['id'];
}

export interface CampaignNetworkScope extends BaseCampaignScope {
  readonly type: CampaignScopeType.NETWORK;
  readonly isNetworkScopedCampaign: boolean;
}

export type CampaignScope = CampaignGroupScope | CampaignNetworkScope;
